/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getIngestUrls.defs.js";
export { main as default } from "./getIngestUrls.defs.js";
